import React, { Component } from "react";
import { connect } from "react-redux";
import { dashboardActions } from "../../../_actions";
import LayoutWrap from "../Component/LayoutWrap";
import { LuCheck, LuCalendarDays, LuClock, LuArrowLeft, LuDownload, LuUploadCloud, LuArrowRight } from 'react-icons/lu';
import { CONST } from '../../../_config';
import { FiUploadCloud } from "react-icons/fi";

import moment from "moment";

const uploadConfig = {
  title: "Case Study Upload",
  formTitle: "Case Study PPT Upload",
  description: "Please upload the same after completion.",
  descriptionSuccess: "The case study document has been uploaded successfully. Awaiting admin review.",
  restrictions: "Only PDF and PPT file can be uploaded. File size should be less then 5 mb.",
  sampleFileUrl: "/path-to-sample.pptx",
  heroImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"
};

class PDFUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingCode: "",
      notes: "",
      file: null,
      selectedFile: null,
      isDragging: false
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));
    this.props.dispatch(dashboardActions.getInsightUploadStatus({}));
  }

  // ✅ Handle File Select
  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      // ✅ File validation
      const allowedTypes = [
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ];

      if (!allowedTypes.includes(file.type)) {
        alert("Only PDF and PPT files are allowed");
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert("File size must be less than 5MB");
        return;
      }

      this.setState({
        selectedFile: file,
        file: file
      });
    }
  };

  // ✅ Drag Over
  onDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  // ✅ Drag Leave
  onDragLeave = () => {
    this.setState({ isDragging: false });
  };

  // ✅ Drop File
  onDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const file = e.dataTransfer.files[0];
    if (file) {

      const allowedTypes = [
        "application/pdf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      ];

      if (!allowedTypes.includes(file.type)) {
        alert("Only PDF and PPT files are allowed");
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        alert("File size must be less than 5MB");
        return;
      }

      this.setState({
        selectedFile: file,
        file: file
      });
    }
  };

  // ✅ Upload API Call
  handleUpload = () => {
    const { file, notes } = this.state;

    if (!file) {
      alert("Please select a file first");
      return;
    }

    let formData = new FormData();
    formData.append("file", file);
    formData.append("notes", notes || "");

    this.props.dispatch(
      dashboardActions.savePDFUpload(formData)
    );
  };

  goToBack = () => {
    window.history.back();
  };



  downloadPDF = async (ele) => {
    const url = CONST.IMAGES_URL;

    if (ele?.file?.fileName) {
      const fileUrl = url + ele.file.fileName;

      try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = ele.file.fileName || "download.pdf";

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Download failed:", error);
      }
    }
  };



  render() {
    let { dashboard } = this.props;
    let { getConnectDetailsData: x, getInsightUploadStatusData } = dashboard;
    let logo = x?.logo || "";

    console.log("getInsightUploadStatusData--->", getInsightUploadStatusData)

    const ele = getInsightUploadStatusData;


    let isUploaded = ele && ele.createdAt ? true : false;

    return (
      <LayoutWrap logo={logo}>
        <div className="min-h-screen bg-white font-sans text-[#212121]">

          {/* Header */}
          <header onClick={() => this.goToBack()} className="flex items-center gap-4 p-4 border-b border-gray-300">
            <button className="p-2 rounded-full bg-indigo-100 text-indigo-600 hover:bg-purple-100 transition">
              <LuArrowLeft size={20} />
            </button>
            <h1 className="text-2xl font-bold">{uploadConfig.title}</h1>
          </header>

          <main className="w-full mx-auto p-6 lg:p-12 py-4">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">

              {/* Left Image */}
              <div className="lg:col-span-4 h-[500px] lg:h-[600px] rounded-3xl overflow-hidden shadow-sm">
                <img
                  src={uploadConfig.heroImage}
                  alt="Workspace"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Right Form */}
              <div className="lg:col-span-8 space-y-4 py-2">

                <div className="space-y-4">
                  <header className="space-y-2">
                    <h2 className="text-2xl font-bold text-gray-800">{uploadConfig.formTitle}</h2>
                    <p className="text-gray-500 font-medium">{isUploaded ? uploadConfig.descriptionSuccess : uploadConfig.description}</p>
                  </header>

                  {isUploaded && false ?
                    <div className="border border-indigo-100 rounded-[32px] p-8 bg-gradient-to-b from-indigo-50/40 to-white">
                      <div className="flex flex-col items-center justify-center text-center">

                        {/* Success Icon */}
                        <div className="w-24 h-24 rounded-full bg-indigo-100 flex items-center justify-center mb-6">
                          <div className="w-16 h-16 rounded-full bg-indigo-600 flex items-center justify-center">
                            <LuCheck className="text-white" size={34} />
                          </div>
                        </div>

                        {/* Title */}
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">
                          You have already uploaded the case study
                        </h3>

                        {/* Subtitle */}
                        <p className="text-gray-500 text-base max-w-lg">
                          Your case study file has been successfully submitted.
                          You can review or download the uploaded document below.
                        </p>

                      </div>
                    </div>
                    :
                    <div
                      onDragOver={this.onDragOver}
                      onDragLeave={this.onDragLeave}
                      onDrop={this.onDrop}
                      className={`relative group border-2 border-dashed rounded-[32px] p-6 flex flex-col items-center justify-center transition-all ${this.state.isDragging
                        ? 'border-purple-600 bg-indigo-100'
                        : 'border-purple-100 bg-gradient-to-b from-purple-50/50 to-white'
                        }`}
                    >
                      <input
                        type="file"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        onChange={this.handleFileChange}
                        accept=".pdf,.ppt,.pptx"
                      />

                      <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-sm mb-6">
                        <LuUploadCloud className="text-indigo-600" size={40} />
                      </div>

                      <h3 className="text-xl font-bold text-gray-800 mb-1">
                        {this.state.selectedFile
                          ? this.state.selectedFile.name
                          : 'Upload file'}
                      </h3>

                      <p className="text-gray-500 font-medium">
                        Drag & drop your file here or{" "}
                        <span className="text-indigo-700 underline">click to browse</span>.
                      </p>
                    </div>}


                  {/* Footer */}
                  {/* {!isUploaded && */}
                  <div className="space-y-6">
                    <p className="text-gray-500 text-sm font-medium">
                      {uploadConfig.restrictions}
                    </p>

                    <button
                      onClick={this.handleUpload}
                      className="flex items-center gap-2 px-10 py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition shadow-lg shadow-purple-200"
                    >
                      Upload <LuArrowRight size={20} />
                    </button>
                  </div>
                  {/* } */}



                </div>


                {isUploaded &&
                  <div className="space-y-4 ">
                    <header className="space-y-2">
                      <h2 className="text-2xl font-bold text-gray-800">{'Upload History'}</h2>
                    </header>

                    <div className="bg-white space-y-4">
                      {ele && ele.createdAt ? (
                        <div className="px-6 py-4 border border-gray-300 rounded-xl p-8 bg-white">
                          <div className='flex justify-between items-center'>
                            <div>
                              <h4 className="text-lg lg:text-xl font-medium textblack mb-2">
                                Uploaded Case Study PDF
                              </h4>

                              <div className="flex flex-wrap items-center gap-4 text-gray-600">
                                <div className="flex items-center gap-2.5 text-indigo-600">
                                  <LuCalendarDays size={20} />
                                  <span>
                                    {ele?.createdAt
                                      ? moment(ele.createdAt).format("DD MMM")
                                      : "-"}
                                  </span>
                                </div>

                                <div className="w-px h-5 bg-indigo-600 hidden md:block"></div>

                                <div className="flex items-center gap-2.5 text-indigo-600">
                                  <LuClock size={20} />
                                  <span>
                                    {ele?.createdAt
                                      ? moment(ele.createdAt).format("hh:mm A")
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                              <button
                                onClick={() => this.downloadPDF(ele)}
                                className="w-full sm:w-auto flex items-center font-medium justify-center gap-2 px-3 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50"
                              >
                                <LuDownload size={20} />
                                Download
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (

                        <div className="flex flex-col items-center justify-center py-20 px-6 rounded-3xl border border-dashed border-gray-300 bg-gradient-to-b from-gray-50 to-white shadow-sm">

                          <div className="flex items-center justify-center w-24 h-24 rounded-full bg-blue-100 text-blue-600 shadow-inner mb-6">
                            <FiUploadCloud size={42} />
                          </div>

                          <h2 className="text-3xl font-semibold text-gray-800 mb-2">
                            No Uploads Found
                          </h2>

                          <p className="text-gray-500 text-center max-w-md leading-relaxed mb-6">
                            User haven't uploaded any files yet.
                          </p>

                        </div>
                      )}
                    </div>

                  </div>
                }



              </div>

            </div>
          </main>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
});

export default connect(mapStateToProps)(PDFUpload);